import { PageLayout } from "../components/ui/Layout";
import HeroSection from "../components/ui/sections/Hero";
import WhyUseSafeLockerSection from "../components/ui/sections/WhyUseSafe";
import WhoCanUseSection from "../components/ui/sections/WhoCanUse";
import HowItWorksSection from "../components/ui/sections/HowItWorks";
import FAQSection from "../components/ui/sections/FAQ";
import LocationSection from "../components/ui/sections/Location";
import ReadyToUseSection from "../components/ui/sections/ReadyToUse";
import TermsAndCondition from "../components/ui/sections/TermsAndCondition";
import { Footer } from "../components/Footer";
import { useEffect } from "react";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <PageLayout>
      <div className="py-10">
        <HeroSection />
        <WhyUseSafeLockerSection />
        <WhoCanUseSection />
        <HowItWorksSection />
        <FAQSection />
        <LocationSection />
        <ReadyToUseSection />
        <TermsAndCondition />
        <Footer /> 
      </div>
    </PageLayout>
  );
};

export default Home;
